import { Box, Stack, Typography } from '@mui/material'
import { SectionTemplate } from '../types'
import { PATH_COLORS } from '../palette'

interface Props {
  template: SectionTemplate
  values: Record<string, string>
  clientName: string
  currentRole: string
  publishedAt?: string
}

export default function HeroSection({ values, clientName, currentRole, publishedAt }: Props) {
  return (
    <Box
      sx={{
        position: 'relative',
        py: { xs: 8, md: 14 },
        mx: { xs: -2, sm: -3, md: -6 },
        px: { xs: 2, sm: 3, md: 6 },
        textAlign: 'center',
        // Soft radial-ish gradient + warm cream wash that sets the editorial tone
        background:
          'radial-gradient(ellipse at top, rgba(201, 149, 74, 0.10) 0%, rgba(251, 249, 244, 0) 60%), linear-gradient(180deg, #f7f2e7 0%, #fbf9f4 100%)',
      }}
    >
      {/* 3-color accent strip — signals the 3-path structure of the document */}
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 4,
          display: 'flex',
        }}
      >
        {PATH_COLORS.map((c, i) => (
          <Box key={i} sx={{ flex: 1, background: c }} />
        ))}
      </Box>

      <Stack spacing={3} alignItems="center">
        <Typography
          variant="overline"
          sx={{ letterSpacing: 4, color: 'text.secondary', fontSize: 12 }}
        >
          MISSFIT MINDSET · CAREER STRATEGY
        </Typography>
        <Typography
          sx={{
            fontFamily: 'var(--ns-display-font)',
            fontWeight: 500,
            fontSize: { xs: 40, sm: 56, md: 76 },
            lineHeight: 1.05,
            letterSpacing: '-0.02em',
            maxWidth: 900,
            // Subtle ink gradient for visual interest without losing legibility
            background: 'linear-gradient(135deg, #1a1a1a 0%, #3a3a3a 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          {clientName}
        </Typography>
        {currentRole && (
          <Typography variant="h6" sx={{ color: 'text.secondary', fontWeight: 400, maxWidth: 600 }}>
            {currentRole}
          </Typography>
        )}
        {values?.tagline && (
          <Typography
            sx={{
              fontFamily: 'var(--ns-display-font)',
              fontStyle: 'italic',
              fontSize: { xs: 18, md: 22 },
              maxWidth: 720,
              color: '#3a3a3a',
              mt: 2,
              borderTop: 1,
              borderBottom: 1,
              borderColor: 'rgba(201, 149, 74, 0.35)',
              py: 2,
              px: 4,
            }}
          >
            {values.tagline}
          </Typography>
        )}
        {publishedAt && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 4, letterSpacing: 2 }}>
            {new Date(publishedAt).toLocaleDateString(undefined, {
              month: 'long',
              year: 'numeric',
            })}
          </Typography>
        )}
      </Stack>
    </Box>
  )
}
